import React from 'react';

const ParameterTable = ({ parameters, isDarkMode = false }) => {
  if (!parameters || parameters.length === 0) return null;

  return (
    <div className="mb-8">
      <h2 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Parameters</h2>
      <div className={`rounded-lg border overflow-hidden ${
        isDarkMode 
          ? 'bg-slate-800 border-slate-700' 
          : 'bg-white border-gray-200'
      }`}>
        <table className={`min-w-full divide-y ${isDarkMode ? 'divide-slate-700' : 'divide-gray-200'}`}>
          <thead className={isDarkMode ? 'bg-slate-700' : 'bg-gray-50'}>
            <tr>
              <th className={`px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${
                isDarkMode ? 'text-slate-300' : 'text-gray-500'
              }`}>Name</th>
              <th className={`px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${
                isDarkMode ? 'text-slate-300' : 'text-gray-500'
              }`}>Type</th>
              <th className={`px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${
                isDarkMode ? 'text-slate-300' : 'text-gray-500'
              }`}>Required</th>
              <th className={`px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${
                isDarkMode ? 'text-slate-300' : 'text-gray-500'
              }`}>Default</th>
              <th className={`px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${
                isDarkMode ? 'text-slate-300' : 'text-gray-500'
              }`}>Description</th>
            </tr>
          </thead>
          <tbody className={`divide-y ${
            isDarkMode 
              ? 'bg-slate-800 divide-slate-700' 
              : 'bg-white divide-gray-200'
          }`}>
            {parameters.map((param, index) => (
              <tr key={index}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <code className={`text-sm font-mono ${isDarkMode ? 'text-slate-100' : 'text-gray-900'}`}>{param.name}</code>
                  {param.in === 'path' && (
                    <span className={`ml-2 inline-flex px-2 py-0.5 text-xs font-medium rounded ${
                      isDarkMode 
                        ? 'bg-purple-600 text-purple-100' 
                        : 'bg-purple-100 text-purple-700'
                    }`}>
                      path
                    </span>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`text-sm ${isDarkMode ? 'text-slate-300' : 'text-gray-600'}`}>{param.type}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {param.required ? (
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                      isDarkMode 
                        ? 'bg-red-600 text-red-100' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      Required
                    </span>
                  ) : (
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                      isDarkMode 
                        ? 'bg-slate-600 text-slate-100' 
                        : 'bg-gray-100 text-gray-600'
                    }`}>
                      Optional
                    </span>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {param.default ? (
                    <code className={`text-sm font-mono ${isDarkMode ? 'text-slate-300' : 'text-gray-600'}`}>{param.default}</code>
                  ) : (
                    <span className={isDarkMode ? 'text-slate-500' : 'text-gray-400'}>-</span>
                  )}
                </td>
                <td className={`px-6 py-4 text-sm ${isDarkMode ? 'text-slate-300' : 'text-gray-600'}`}>
                  {param.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ParameterTable;
